import { HttpEndpoint } from '@/api/httpEndpoints';
import { delay } from '@shared/utils/async';
import { metaFakeItineraryData } from './itinerary.fake';
import {
    ItineraryEndpoint as ItineraryEndpointModel,
    ItineraryBookData,
} from './itinerary.interfaces';
import fakeItineraryJSON from '@/api/Itinerary/itinerary.fake.json';

export class ItineraryEndpoint extends HttpEndpoint implements ItineraryEndpointModel {
    constructor(applicationUrl: string) {
        super(applicationUrl);
    }
    public async GetItineraryData(identifier: string): Promise<ItineraryBookData> {
        return await this.get<ItineraryBookData>(
            this.buildPathWithQuery('mvc/flight/ItineraryData', {
                identifier,
            })
        );
    }

    public FindOptimalItinerary() {
        return this.get('mvc/Flight/FindOptimalItinerary');
    }
}

export class FakeItineraryEndpoint implements ItineraryEndpointModel {
    public async GetItineraryData(): Promise<ItineraryBookData> {
        await delay(1500);
        const hasJSON = fakeItineraryJSON && Object.keys(fakeItineraryJSON).length > 0;

        if (hasJSON) {
            return fakeItineraryJSON as any;
        } else {
            return metaFakeItineraryData;
        }
    }

    public async FindOptimalItinerary() {
        return;
    }
}
